<template>
  <section v-if="items.length">
    <v-container>
      <TitleWidget>{{ title }}</TitleWidget>

      <CarouselWidget
        class="mt-10 mt-md-13"
        :items="items"
        v-bind="carouselSettings"
      >
        <template #item="{ item }">
          <ServiceCard v-bind="item" />
        </template>
      </CarouselWidget>
    </v-container>
  </section>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import ServiceCard from "../cards/ServiceCard.vue";

const _data = {
  title: "Serviços",
  items: [
    {
      icon: require("../../assets/img/services/01.png"),
      title: "Locação de Impressoras",
    },
    {
      icon: require("../../assets/img/services/02.png"),
      title: "Assistência de Impressoras e Informática",
    },
    {
      icon: require("../../assets/img/services/03.png"),
      title: "Venda de Toners Compatíveis",
    },
    {
      icon: require("../../assets/img/services/04.png"),
      title: "Sistemas de Câmeras (CFTV)",
    },
  ],
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    carouselSettings() {
      const items = {
        itemsToShow: {
          xs: 2,
          sm: 3,
          md: 3,
          lg: 4,
          xl: 4,
        },
        dots: true,
      };

      switch (this.$vuetify.breakpoint.name) {
        case "xl":
          items.gap = 80;
          break;
        case "lg":
        case "md":
          items.gap = 52;
          break;
        case "sm":
          items.gap = 24;
          break;
        default:
          items.gap = 12;
      }

      return items;
    },
  },
  components: {
    TitleWidget,
    CarouselWidget,
    ServiceCard,
  },
};
</script>
